module.exports = __webpack_public_path__ + "static/media/conf.c32bc167.svg";